import React, { FC, SVGProps } from 'react'

import { Colors } from 'common-constants/colors'

interface IconActiveEditFieldSvgProps extends SVGProps<SVGSVGElement> {
  size?: number
}

export const IconActiveEditFieldSvg: FC<IconActiveEditFieldSvgProps> = ({
  size = 24,
  color = Colors.link,
  ...rest
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3527 7.12344L8.78306 17.693L3.74738 19.3404L5.41922 14.3306L15.9903 3.7596L19.3527 7.12344Z"
      fill={color}
      stroke={color}
      strokeWidth="1.35"
      strokeLinejoin="round"
    />
  </svg>
)
